import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class MegaMenuService {

    retailStyle: string;

    solarStyle: string;

    burgerStyle: string;
}